import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Model from './Model';
import ContentHeightSubject from './ContentHeightSubject';

ContentHeightSubject.init(500);

fetch("https://igors-pest-vulnerability-matrix-ui.s3-us-west-1.amazonaws.com/pvm-allData.json")
.then(res => res.json())
.then(json => new Model(json))
.then(model => 
  ReactDOM.render(
    <>
    {/*<React.StrictMode> */}
        <App model={model} />
    {/*</React.StrictMode>*/}
    </>,
    document.getElementById('root')
  ));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();